module.exports = __webpack_public_path__ + "img/fa3602f.jpg";